module.exports = __webpack_public_path__ + "static/media/BauPro-Bold.fb4904ac.otf";